import { Security_Status } from '@/__generated__/graphql';
import { MinusScoreIcon } from '@/assets/icons/minusScore';
import { Tooltip } from '@/components/basicComponents/tooltip';
import NoResults from '@/components/table/noResults';
import RedirectTitleCell from '@/components/table/redirectTitleCell';
import { getUTCDate } from '@/shared/utils/date';
import { themeVar } from '@/styles/theme';
import styled from 'styled-components';
import { TableRowCell, TableRowWrapper, TextCell } from '../../table/styles';
import { recommendedTableColumns } from '../constants';
import { IInvestorInterestList, TypeWindow } from '../types';

interface RecommendedTableBodyProps {
  recommendedData: IInvestorInterestList[];
  openPage: (id: string, type: TypeWindow) => void;
}

const TableBody = ({ recommendedData, openPage }: RecommendedTableBodyProps) => {
  if (!recommendedData?.length) {
    return <NoResults />;
  }

  return (
    <>
      {recommendedData.map((row) => (
        <TableRowWrapper key={row.investment.id}>
          <TableRowCell width={recommendedTableColumns[0].width}>
            <RedirectTitleCell id="actionCurioText" onClick={() => openPage(row.investment.id, 'opportunityDetails')}>
              {row.investment.name}
            </RedirectTitleCell>
          </TableRowCell>
          <TableRowCell width={recommendedTableColumns[1].width}>
            <TextCell>
              {row.investment?.subAssetClass
                ? `${row.investment?.assetClass?.name} - ${row.investment?.subAssetClass?.name}`
                : row.investment?.assetClass?.name}
            </TextCell>
          </TableRowCell>
          <TableRowCell width={recommendedTableColumns[2].width}>
            <TextCell>
              {row.investment?.subAssetClasses?.length > 1 ? (
                <Tooltip title={row.investment.subAssetClasses.toString().replace(/,/g, ', ')}>
                  Multiple ({row.investment.subAssetClasses.length})
                </Tooltip>
              ) : (
                row.investment?.subAssetClasses && row.investment?.subAssetClasses[0]
              )}
            </TextCell>
          </TableRowCell>
          <TableRowCell width={recommendedTableColumns[3].width}>
            <TextCell>{row.investment.type}</TextCell>
          </TableRowCell>
          <TableRowCell width={recommendedTableColumns[4].width}>
            <TextCell>{row.investment.investorDocsDue && getUTCDate(new Date(row.investment.investorDocsDue))}</TextCell>
          </TableRowCell>
          {/* <TableRowCell width={otherRecommendedTableColumns[5].width}>
            {row.investment.securityStatus === Security_Status.Terminated && (
              <TooltipWrapper>
                <Tooltip title="Passed On">
                  <MinusScoreIcon width={29} height={29} fill={themeVar('font.disabled')} />
                </Tooltip>
              </TooltipWrapper>
            )}
          </TableRowCell> */}
        </TableRowWrapper>
      ))}
    </>
  );
};

export default TableBody;

const TooltipWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  top: 3px;
`;
